import PageShell from "@/components/PageShell";
import PageHero from "@/components/PageHero";
import { Link } from "react-router-dom";
import { Download, FileText } from "lucide-react";

const SECTIONS = [
    "Executive summary",
    "Protocol architecture",
    "Compute layer",
    "Storage layer",
    "Layer-1 blockchain",
    "AI layer",
    "DNS",
    "Token economics",
    "Security model",
    "Roadmap",
];

const PDF = "https://customer-assets.emergentagent.com/job_15903e42-892a-4550-8865-b8948fdc7338/artifacts/9n4ktw5d_DeCloudX_Technical_Whitepaper_v3.pdf";

export default function WhitepaperPage() {
    return (
        <PageShell>
            <PageHero
                eyebrow="Whitepaper"
                title="DeCloudX Technical"
                accent="Whitepaper."
                sub="A technical specification for a patent-filed hybrid decentralized cloud architecture combining compute, storage, Layer-1 settlement, AI routing, on-chain DNS, and developer revenue sharing."
            >
                <div className="flex flex-wrap gap-3">
                    <a href={PDF} target="_blank" rel="noreferrer" className="btn-primary" data-testid="wp-download">
                        <Download size={15} strokeWidth={1.5} /> Download Whitepaper
                    </a>
                    <a href="https://decloudx.gitbook.io/decloudx" target="_blank" rel="noreferrer" className="btn-secondary">
                        <FileText size={15} strokeWidth={1.5} /> Read Online
                    </a>
                </div>
            </PageHero>

            <section className="relative py-16 md:py-24 border-t border-line">
                <div className="max-w-7xl mx-auto px-6 md:px-10">
                    <div className="overline mb-3">Table of Contents</div>
                    <h2 className="font-heading font-black text-2xl sm:text-3xl text-ink max-w-3xl">Architecture, economics, and security — in one document.</h2>
                    <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3">
                        {SECTIONS.map((s, i) => (
                            <div key={i} className="surface card-lift p-5 rounded-xl" data-testid={`wp-section-${i}`}>
                                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-faint-ink">{String(i+1).padStart(2,"0")}</div>
                                <div className="font-heading font-bold text-sm text-ink mt-1.5">{s}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </PageShell>
    );
}
